import React, { useState } from "react";
import QRCode from "qrcode";                 // OLD library
import { QRCodeCanvas } from "qrcode.react"; // NEW library

export default function GenrateQR() {
  const [text, setText] = useState("");
  const [qr, setQr] = useState("");

  // OLD LIBRARY GENERATOR
  const generateQR = async () => {
    try {
      const url = await QRCode.toDataURL(text);
      setQr(url);
    } catch (err) {
      console.error(err);
    }
  };

  // Download for qrcode.react canvas
  const downloadCanvasQR = () => {
    const canvas = document.getElementById("react-qr");
    if (!canvas) return;
    const url = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = url;
    link.download = "qr-react.png";
    link.click();
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>QR Code Generator</h2>

      <input
        type="text"
        placeholder="Enter text or URL"
        value={text}
        onChange={(e) => setText(e.target.value)}
        style={{ padding: 8, width: 250 }}
      />

      <br /><br />

      {/* ===== OLD LIBRARY BUTTON ===== */}
      <button onClick={generateQR}>
        Generate QR (qrcode lib)
      </button>

      <br /><br />

      {/* ===== OLD LIBRARY OUTPUT ===== */}
      {qr && (
        <div>
          <p>QR from qrcode library:</p>
          <img src={qr} alt="QR Code" />
        </div>
      )}

      <hr />

      {/* ===== NEW LIBRARY OUTPUT ===== */}
      {text && (
        <div>
          <p>QR from qrcode.react:</p>
          <QRCodeCanvas
            id="react-qr"
            value={text}
            size={220}
            level="H"
            includeMargin
          />

          <br />
          <button onClick={downloadCanvasQR}>
            Download React QR
          </button>
        </div>
      )}
    </div>
  );
}
